<template>
  <div class="cs-box-item">
    <div class="product-name mb-50 d-flex justify-content-center">
      <feather-icon icon="CheckCircleIcon" size="22" class="text-success" />
      <span
        class="text-primary text-center"
        style="font-weight: 500; font-size: 18px; flex: 1"
      >Phiếu chỉ định</span>
    </div>
    <div class="d-flex items-center my-2 justify-center">
      <div
        class="d-flex flex-column justify-center"
        style="gap: 5px;"
        @click="handleOpenIndicatorForm"
      >
        <b-link
          v-b-tooltip.top
          title="phieu_chi_dinh"
          target="_blank"
          class="flex"
          style="gap: 6px"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
              fill="#20419b"
            />
          </svg>
          <span style="flex: 1; line-height: 24px; text-wrap: nowrap;">phieu_chi_dinh</span>
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmitFormItemIndicator',
  props: {
    orderDetail: {},
    itemID: Number
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    handleOpenIndicatorForm() {
      this.$router.push({
        name: 'PrintIndicatorForm',
        params: {
          orderDetail: this.orderDetail.id
        },
        query: { order_id: this.itemID }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-none {
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  &:focus-visible {
    outline: #4b6ecf dotted 0.5px;
  }
}
.product-name {
  font-weight: 600;
}
.description {
  font-size: 12px;
  margin-bottom: 5px;
  a {
    text-decoration: underline;
  }
}

.cs-box-item {
  border: 1px solid #20409b;
  padding: 12px;
  border-radius: 4px;
}

.cs-dropdown ::v-deep {
  button {
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;

    &:hover {
      background-color: transparent !important;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
    }

    &::after {
      display: none !important;
    }
  }
}

svg:focus {
  outline: none;
}
</style>>